<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <span class="headline mb-0">用户登录</span>
      </v-card-title>
      <v-card-text>
        <h3>处理Point</h3>
        <ol>
          <li>新用户可以通过“新規申込”按钮跳转到新用户注册页面（B0400）进行自助注册（注册页面进入前请显示【显示语言】选在框或页面）</li>
          <li>新用户初次登录系统时提示更改密码-强制更改密码（可以直接跳转密码修改页面）</li>
          <li>登录密码需要定期强制提示用户更改（强制确认期间可设定）同时可以确认登录信息（所属公司、部所、职位、联络方式）</li>
          <li>强制每1个月（注册申请日为基准计算）对用户信息进行确认，（所属公司、部所、职位、联络方式），同时允许用户随时可以对其进行编辑</li>
          <li>用户使用页面的显示语言可以进行设定（日，英，中）--（多语言对应的页面只限于海外用户需要使用的页面--INV P/L登录、S/A登录、诸费用登录页面）</li>
          <li>用户群组分为 A: SJL 用户；B: SHARP 用户； C:物流供应商（サプライヤー）；D:海外发货人（海外取引先）</li>
          <li>用户ID需要设定有效期限</li>
        </ol>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {}
  }
}
</script>
<style scoped>
</style>
